<template>
  <div class="materials-select">
    <el-dialog :title="materialsTitle" :visible.sync="materialsVisible" :close-on-click-modal="materialsModalClose"
      @close="handleSelectCancel" width="45%">
      <el-form :model="queryForm" ref="queryForm" :inline="true">
        <el-form-item label="姓名">
          <el-input v-model="queryForm.nickName" placeholder="请输入姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearchMaterials">查询</el-button>
          <el-button @click="handleResetMaterials">重置</el-button>
        </el-form-item>
      </el-form>
      <div>
        <div style="display: flex; justify-content: center;">
          <el-transfer v-model="materialsSelectArr" :data="materialsData" filterable :filter-method="filterMethod"
            :titles="['选择列表', '已选择']" filter-placeholder="请输入搜索内容" :props="transferProps">
            <span slot-scope="{ option }">{{ option.label }}</span>
          </el-transfer>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSelectConfirm">确 定</el-button>
        <el-button @click="handleSelectCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
export default {
  name: 'PeopleSelect',
  data() {
    return {
      materialsTitle: '选择人员',
      materialsVisible: false,
      materialsModalClose: false,
      queryForm: {
        nickName: ''
      },
      materialsData: [],
      materialsSelectArr: [],
      transferProps: {
        key: "value",
        label: "label",
      },
      confirmArr: []
    }
  },
  created() {
    this.queryMaterialsList()
  },
  methods: {
    openDialog() {
      this.materialsVisible = true;
    },
    queryMaterialsList() {
      this.$fetch(api.queryAllPerson, {
        pageNo: 1,
        pageSize: 10000,
        containOwnFlag: '1',
        nickName: this.queryForm.nickName
      }).then((res) => {
        if (res.success) {
          this.materialsData = res.returnObj.list.map((item) => {
            return {
              label: item.nickName,
              value: item.accountNumber
            };
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 查询所有设备
    handleSearchMaterials() {
      this.queryMaterialsList();
    },
    // 重置查询所有设备
    handleResetMaterials() {
      this.queryForm.nickName = ''
      this.queryMaterialsList();
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    handleSelectCancel() {
      this.materialsSelectArr = [];
      this.materialsVisible = false;
    },
    handleSelectConfirm() {
      if (this.materialsSelectArr.length === 0) {
        this.$message({
          message: '请选择人员',
          type: 'warning'
        });
        return
      }
      this.confirmArr = []
      const arr = this.materialsSelectArr.map((key) => {
        return {
          nickName:
            this.materialsData[
              this.materialsData.findIndex((item) => item.value === key)
            ].label,
          accountNumber:
            this.materialsData[
              this.materialsData.findIndex((item) => item.value === key)
            ].value
        };
      });
      this.confirmArr = this.confirmArr.concat(arr);
      this.handleSelectCancel();
      this.$emit('selectArr', this.confirmArr)
    }
  }
}
</script>

<style>
.materials-select .el-transfer-panel {
  width: 32%;
}
.materials-select .el-transfer-panel__list.is-filterable {
  height: 85%;
}
</style>
